import { paddingLabel } from '../M611/M611.data';
import { labelWidth } from '../../../HMISection/Data/P710/P710.data';
import { AsFoundResultP723Formula } from './P723.formula';
import { Result } from 'journeys/portal/Forms/Sections.constants';

export const AsFoundTestTableSectionDataP723 = (selectedTag, formData) => ({
    rows: [
        {
            key: 1,
            fields: [{
                key: 'As-FoundTest',
                label: 'As-Found Test',
                isLabel: true,
                xs: 12,
                fontWeight: '700',
                padding: '5px 0 0 8px'
            }]
        },
        {
            key: 2,
            fields: [
                {
                    key: 'F460AftPushbuttonWasActivatedInFieldLabel',
                    label: 'Pushbutton Was Activated in Field?',
                    xs: 4,
                    labelWidth: '100%',
                    padding: paddingLabel,
                    isLabel: true,
                    fontWeight: '600',
                    fontSize: '9pt',
                },
                {
                    key: 'F460AftPushbuttonWasActivatedInField',
                    value: formData.F460AftPushbuttonWasActivatedInField,
                    isRequired: true,
                    isDropdown: true,
                    placeholder: 'Select YES or NO',
                    options: [{ name: 'Select YES or NO', value: '' },
                    { name: 'YES', value: 'YES' },
                    { name: 'NO', value: 'NO' }],
                    labelWidth: '0',
                    width: '100%',
                    inputTextAlign: 'center',
                    xs: 2,
                    borderBottom: '0',
                    height: '1.5rem',
                }
            ]
        },
        {
            key: 3,
            fields: [
                {
                    key: 'F372AftHmistatus1Label',
                    label: 'HMI Status',
                    xs: 4,
                    labelWidth: '100%',
                    padding: paddingLabel,
                    isLabel: true,
                    fontWeight: '600',
                    fontSize: '9pt',
                },
                {
                    key: 'F372AftHmistatus1',
                    value: formData.F372AftHmistatus1,
                    isRequired: true,
                    isDropdown: true,
                    placeholder: 'Select HMI Status',
                    options: [{ name: 'Select HMI Status', value: '' },
                    { name: 'NORMAL', value: 'NORMAL' },
                    { name: 'ALARM', value: 'ALARM' },
                    { name: 'FAULT', value: 'FAULT' }],
                    labelWidth: '0',
                    width: '100%',
                    inputTextAlign: 'center',
                    xs: 2,
                    borderBottom: '0',
                    marginBottom: '0',
                    height: '1.55rem',
                },
                {
                    key: 'F102AftResultLabel',
                    label: Result.AS_FOUND_RESULT_LABEL,
                    xs: 4,
                    isLabel: true,
                    fontWeight: '700',
                    labelWidth,
                    fontSize: '9pt',
                    textAlign: 'right',
                    padding: '4px 5px 0 0',
                },
                {
                    key: 'F102AftResult',
                    value: AsFoundResultP723Formula(formData),
                    width: '100%',
                    readOnly: true,
                    labelWidth: '0',
                    isCalculatedNew: true,
                    xs: 2,
                    textAlign: 'center',
                    height: '1.3rem',
                    borderRight: '0',
                    borderBottom: '0',
                    direction: 'rtl',
                    marginBottom: '4px',
                    inputMarginRight: '4px',
                    isLabelBold: true,
                    fontWeight: '700'
                }
            ]
        },
    ]
});
